import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { SignInForm } from './components/SignInForm';
import { SignInGoogle } from './components/SignInGoogle';

export const PageSignIn = () => {
    return (
        <Routes>
            <Route index element={<Navigate to='/sign-in/google' replace />} />
            <Route path='google' element={<SignInGoogle />} />
            <Route path='manual' element={<SignInForm />} />
            <Route path='*' element={<Navigate to='/sign-in/google' replace />} />
        </Routes>
    );
};
